import React, { useCallback, useEffect } from 'react'
import { Box, Button, Icon, Stack } from '@chakra-ui/react'
import {
  LabeledInput,
  Checkbox,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody
} from '@apex/component-library'
import { FaQuestionCircle } from 'react-icons/fa'
import { useFormikContext } from 'formik'
import { COLUMN_WIDTH, MAX_COLUMN_WIDTH } from '../../utils'

export interface TransferAmountProps {
  value: string
  isDisabled: boolean
  errorMessage?: string
  handleBlur: (e: any) => void
  handleAmountChange: (e: any) => void
  isInvalid?: boolean
  totalBalanceChecked: boolean
  handleCheckboxChange: (e: any) => void
}

interface TransferAmountValues {
  totalBalanceCheckbox: boolean
  transferAmountDisplay: string
  transferAmountRaw: number
}

export const TransferAmount = ({
  value,
  isDisabled,
  errorMessage,
  handleBlur,
  handleAmountChange,
  isInvalid,
  totalBalanceChecked,
  handleCheckboxChange
}: TransferAmountProps) => {
  const formik = useFormikContext<TransferAmountValues>()
  const clearTransferAmount = () => {
    formik.setFieldValue('transferAmountDisplay', '')
    formik.setFieldValue('transferAmountRaw', 0)
    formik.setFieldTouched('transferAmountRaw', false)
  }

  const clearTransferAmountMemo = useCallback(clearTransferAmount, [])

  useEffect(() => {
    if (formik.values.totalBalanceCheckbox) {
      clearTransferAmountMemo()
    }
  }, [formik.values.totalBalanceCheckbox, clearTransferAmountMemo])
  return (
    <Box>
      <Stack direction='row' spacing={4}>
        <Box width={COLUMN_WIDTH} maxW={MAX_COLUMN_WIDTH}>
          <LabeledInput
            label='Transfer Amount'
            isRequired
            iconLeft='$'
            value={value}
            name='transferAmountRaw'
            isDisabled={isDisabled}
            errorMessage={errorMessage}
            className={'test-id-transfer-amount'}
            onBlur={handleBlur}
            onChange={handleAmountChange}
            isInvalid={isInvalid}
          />
        </Box>
        <Box paddingTop={9} w='165px' whiteSpace='nowrap'>
          <Checkbox
            isChecked={totalBalanceChecked}
            name='totalBalanceCheckbox'
            className={'test-id-total-balance-checkbox'}
            data-testid={'total-balance-checkbox'}
            onChange={handleCheckboxChange}
          >
            Total Balance
          </Checkbox>
          <Popover
            modifiers={[
              {
                name: 'offset',
                options: {
                  offset: [-5, 10]
                }
              }
            ]}
          >
            <PopoverTrigger>
              <Button
                aria-label='Transfer Amount popover'
                variant='link'
                h='1rem'
                d='inline-block'
                minW='1rem'
                lineHeight={0}
                border={0}
                rounded='full'
                ml='3px'
              >
                <Icon as={FaQuestionCircle} color='black'>
                  Trigger Popover
                </Icon>
              </Button>
            </PopoverTrigger>
            <PopoverContent color='black' whiteSpace='normal'>
              <PopoverArrow />
              <PopoverBody>
                The Total Balance transferred may be less than the Amount Available due to intraday activity, fee
                assessments and pending debit interest and dividends.
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </Box>
      </Stack>
    </Box>
  )
}
